import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

export default function MonCashCallbackPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { token } = useAuth();

    const [status, setStatus] = useState("verifying"); // verifying | success | error
    const [message, setMessage] = useState("");
    const [storeId, setStoreId] = useState(null);

    useEffect(() => {
        const orderId = searchParams.get("orderId") || searchParams.get("order_id");
        if (!orderId) {
            setStatus("error");
            setMessage("Paramètre de commande manquant.");
            return;
        }

        const verify = async () => {
            try {
                const res = await axios.get(`${API_URL}/payments/moncash/verify`, {
                    params: { order_id: orderId },
                    headers: { Authorization: `Bearer ${token}` },
                });
                setStoreId(res.data.store_id);
                setStatus("success");
                setMessage(res.data.message || "Paiement confirmé !");
            } catch (err) {
                setStatus("error");
                setMessage(
                    err.response?.data?.detail ||
                    "Le paiement n'a pas pu être confirmé. Contactez le support si le montant a été débité."
                );
            }
        };

        verify();
    }, [searchParams, token]);

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center space-y-6">
                {status === "verifying" && (
                    <>
                        <Loader2 className="h-16 w-16 text-orange-500 animate-spin mx-auto" />
                        <h2 className="text-xl font-bold text-gray-800">Vérification du paiement…</h2>
                        <p className="text-gray-500 text-sm">Merci de patienter quelques secondes.</p>
                    </>
                )}

                {status === "success" && (
                    <>
                        <CheckCircle2 className="h-16 w-16 text-green-500 mx-auto" />
                        <h2 className="text-2xl font-bold text-gray-900">Paiement réussi !</h2>
                        <p className="text-gray-600 text-sm">{message}</p>
                        <div className="flex flex-col gap-3 pt-2">
                            {storeId && (
                                <Button
                                    className="w-full bg-orange-500 hover:bg-orange-600"
                                    onClick={() => navigate(`/seller/dashboard/${storeId}`)}
                                >
                                    Accéder à mon dashboard
                                </Button>
                            )}
                            <Button variant="outline" className="w-full" onClick={() => navigate("/mes-boutiques")}>
                                Voir mes boutiques
                            </Button>
                        </div>
                    </>
                )}

                {status === "error" && (
                    <>
                        <XCircle className="h-16 w-16 text-red-500 mx-auto" />
                        <h2 className="text-2xl font-bold text-gray-900">Paiement non confirmé</h2>
                        <p className="text-gray-600 text-sm">{message}</p>
                        <div className="flex flex-col gap-3 pt-2">
                            <Button variant="outline" className="w-full" onClick={() => navigate("/mes-boutiques")}>
                                Retour à mes boutiques
                            </Button>
                            <a
                                href="mailto:support@buymoreeasy.com"
                                className="text-sm text-orange-500 hover:underline"
                            >
                                Contacter le support
                            </a>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
